<template>
  <section class="about">
    <div class="about__watermark"></div>

    <div class="about__inner">
      <!-- 左侧文案 -->
      <div class="about__text" >
        <p class="about__en">ABOUT US</p>
        <h2 class="about__title">
          <img src="@/assets/logo.png" alt="绿豚陪诊" class="about__title-logo" />
          <span>绿豚陪诊</span>
          <span class="about__dots">
            <i></i><i></i><i></i>
          </span>
        </h2>

        <h3 class="about__company">绿豚嘀嘀陪同（上海）医疗科技有限公司</h3>

        <p class="about__desc">
          绿豚陪诊是专注于医疗陪诊领域的互联网服务平台，公司成立于 2023 年，注册资本 5000 万人民币，
          以“专业陪伴，全程无忧”为核心理念，致力于成为老百姓最信赖的“就医管家”，打造陪诊界的打车软件。
          平台连接专业陪诊师与海量就医需求，为用户提供医院就诊陪同、排队取号、报告代取、问诊协助等全流程服务，
          解决独自看病、家属无暇陪护的就医痛点。
        </p>
        <p class="about__desc">
          我们以赋能合作伙伴、服务大众健康为初心，立志打造老百姓身边的专业就医管家，
          聚力搭建陪诊生态供应链联盟，联动医药、健康服务行业同仁，深耕银发健康服务市场，
          共建普惠便民的就医服务体系。
        </p>
        <p class="about__desc">
          公司依托专业医疗资源与数字化服务模式，通过规范化的服务人员管理体系，
          简化就医繁琐流程，减少就诊奔波，帮助老人、异地就诊、行动不便人群轻松就医。
          服务网络以上海为核心，逐步覆盖周边区域，App 已上线 OPPO、vivo、小米、华为、苹果五大应用商店，
          让每一次就医更有温度、更有效率。
        </p>
      </div>

      <!-- 右侧图片 -->
      <div class="about__image">
        <div class="about__img-wrap">
          <div class="about__img-placeholder">
            <img
                src="https://ltfxpz.oss-cn-shanghai.aliyuncs.com/other/%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_1792375306101.png"
                alt="绿豚陪诊服务场景"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 底部品牌色块：绝对定位，不遮挡内容 -->
    <div class="about__banner">
      <p class="about__slogan">专业陪伴 · 全程无忧</p>
    </div>
  </section>
</template>

<script setup>
// 纯展示
</script>

<style scoped>

.about {
  position: relative;
  background: #ffffff;
  padding: 100px 0 180px;      /* 底部留白同步缩小 */
  overflow: hidden;
}

.about__watermark {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 60%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'%3E%3Cg fill='none' stroke='%23e2e8f0' stroke-width='1'%3E%3Crect x='50' y='150' width='60' height='200'/%3E%3Crect x='130' y='100' width='80' height='250'/%3E%3Crect x='230' y='180' width='50' height='170'/%3E%3Crect x='300' y='220' width='70' height='130'/%3E%3Cline x1='0' y1='350' x2='400' y2='350'/%3E%3C/g%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: contain;
  opacity: 0.5;
  pointer-events: none;
  z-index: 0;
}

/* ===== 主体：整体往左移 ===== */
.about__inner {
  position: relative;
  z-index: 1;
  max-width: 1450px;                      /* 1440 → 1320，容器收窄，整体靠左 */
  margin: 0 auto;
  padding: 0 20px 0 0;                    /* 右侧留 0，左侧不留 → 内容偏左 */
  display: grid;
  grid-template-columns: 1.4fr 0.8fr;
  gap: 80px;
  align-items: flex-start;
}

/* 左侧文字：贴左 */
.about__text {
  justify-self: start;
}

/* 右侧图片 */
.about__image {
  justify-self: end;
  width: 100%;
  padding-top: 60px;
}

/* ===== 左侧文案 ===== */
.about__en {
  font-size: 14px;
  letter-spacing: 4px;
  color: #8a9aa8;
  margin-bottom: 18px;
}

.about__title {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  font-size: 50px;
  font-weight: 800;
  color: var(--gt-primary);
  line-height: 1.2;
  margin-bottom: 36px;
}
.about__title-logo {
  height: 68px;
  width: auto;
  object-fit: contain;
}

.about__dots {
  display: inline-flex;
  gap: 6px;
  margin-left: 4px;
}
.about__dots i {
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--gt-secondary);
  opacity: 0.5;
}
.about__dots i:nth-child(2) { opacity: 0.75; }
.about__dots i:nth-child(3) { opacity: 1; }

.about__company {
  font-size: 23px;
  font-weight: 700;
  color: #1f2d3d;
  margin-bottom: 26px;
  line-height: 1.5;
}

.about__desc {
  font-size: 17px;
  color: #4a5a6a;
  line-height: 2.1;
  margin-bottom: 18px;
}

/* ===== 右侧图片 ===== */
.about__img-wrap {
  position: relative;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}
.about__img-placeholder {
  width: 100%;
  aspect-ratio: 4 / 3;
  background: linear-gradient(135deg, #e8f2fb 0%, #e6f5f3 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8a9aa8;
  font-size: 15px;
  letter-spacing: 2px;
}

/* ===== 底部品牌色块：整体缩小 ===== */
.about__banner {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 60%;                              /* 55% → 42% */
  height: 110px;                           /* 150 → 110 */
  background: linear-gradient(90deg, #1a6fb5 0%, #145a94 100%);
  clip-path: polygon(0 30%, 6% 0, 100% 0, 100% 100%, 0 100%);
  display: flex;
  align-items: center;
  padding-left: 400px;                      /* 100 → 80 */
}
.about__slogan {
  font-size: 26px;                         /* 34 → 26 */
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 5px;                     /* 6 → 5 */
  line-height: 1.2;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.18);
}

/* ===== 响应式 ===== */
@media (max-width: 1300px) {
  .about__inner { gap: 50px; padding: 0 24px 0 0; }
  .about__text { padding-left: 24px; }
  .about__title { font-size: 42px; }
  .about__title-logo { height: 58px; }
  .about__company { font-size: 20px; }
  .about__desc { font-size: 16px; line-height: 2; }
  .about__banner { width: 46%; height: 100px; padding-left: 60px; }
  .about__slogan { font-size: 22px; letter-spacing: 4px; }
}

@media (max-width: 900px) {
  .about { padding: 60px 0 140px; }
  .about__inner {
    grid-template-columns: 1fr;
    gap: 40px;
    padding: 0 24px;
  }
  .about__text { justify-self: stretch; padding-left: 0; }
  .about__image { justify-self: stretch; padding-top: 0; }
  .about__title { font-size: 32px; }
  .about__title-logo { height: 44px; }
  .about__company { font-size: 18px; }
  .about__desc { font-size: 15px; line-height: 1.9; }
  .about__banner {
    width: 100%;
    height: 80px;
    clip-path: none;
    padding-left: 0;
    justify-content: center;
  }
  .about__slogan {
    font-size: 18px;
    letter-spacing: 3px;
    text-align: center;
  }
  .about__watermark { display: none; }
}

.about__img-wrap {
  position: relative;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(26, 111, 181, 0.12);
}
.about__img-wrap img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

</style>
